"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proto = void 0;
const socket_messages_1 = require("../socket_messages");
const compiled_1 = require("./compiled");
var proto;
(function (proto_1) {
    class TxAppleLogin extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxAppleLogin.type, true);
            this.protoClass = compiled_1.authentication.AppleLogin;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxAppleLogin(compiled_1.authentication.AppleLogin.create(properties));
        }
    }
    TxAppleLogin.type = 'apple-login';
    proto_1.TxAppleLogin = TxAppleLogin;
    class TxLogin extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxLogin.type, true);
            this.protoClass = compiled_1.authentication.Login;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxLogin(compiled_1.authentication.Login.create(properties));
        }
    }
    TxLogin.type = 'login';
    proto_1.TxLogin = TxLogin;
    class RxLoginError extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxLoginError.type, message);
            this.proto = compiled_1.authentication.LoginError.create({});
            this.protoClass = compiled_1.authentication.LoginError;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxLoginError(message);
        }
        ;
    }
    RxLoginError.type = 'login-error';
    proto_1.RxLoginError = RxLoginError;
    class RxLoginToken extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxLoginToken.type, message);
            this.proto = compiled_1.authentication.LoginToken.create({});
            this.protoClass = compiled_1.authentication.LoginToken;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxLoginToken(message);
        }
        ;
    }
    RxLoginToken.type = 'login-token';
    proto_1.RxLoginToken = RxLoginToken;
    class RxTokenInvalid extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxTokenInvalid.type, message);
            this.proto = compiled_1.authentication.TokenInvalid.create({});
            this.protoClass = compiled_1.authentication.TokenInvalid;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxTokenInvalid(message);
        }
        ;
    }
    RxTokenInvalid.type = 'token-invalid';
    proto_1.RxTokenInvalid = RxTokenInvalid;
    class TxVerifyToken extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxVerifyToken.type, true);
            this.protoClass = compiled_1.authentication.VerifyToken;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxVerifyToken(compiled_1.authentication.VerifyToken.create(properties));
        }
    }
    TxVerifyToken.type = 'verify-token';
    proto_1.TxVerifyToken = TxVerifyToken;
    class RxFormErrors extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxFormErrors.type, message);
            this.proto = compiled_1.form_errors.FormErrors.create({});
            this.protoClass = compiled_1.form_errors.FormErrors;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxFormErrors(message);
        }
        ;
    }
    RxFormErrors.type = 'form-errors';
    proto_1.RxFormErrors = RxFormErrors;
    class TxDeleteFile extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxDeleteFile.type, true);
            this.protoClass = compiled_1.sfiles.DeleteFile;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxDeleteFile(compiled_1.sfiles.DeleteFile.create(properties));
        }
    }
    TxDeleteFile.type = 'delete-file';
    proto_1.TxDeleteFile = TxDeleteFile;
    class RxUploadDone extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUploadDone.type, message);
            this.proto = compiled_1.sfiles.UploadDone.create({});
            this.protoClass = compiled_1.sfiles.UploadDone;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUploadDone(message);
        }
        ;
    }
    RxUploadDone.type = 'upload-done';
    proto_1.RxUploadDone = RxUploadDone;
    class TxUploadEnd extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxUploadEnd.type, true);
            this.protoClass = compiled_1.sfiles.UploadEnd;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxUploadEnd(compiled_1.sfiles.UploadEnd.create(properties));
        }
    }
    TxUploadEnd.type = 'upload-end';
    proto_1.TxUploadEnd = TxUploadEnd;
    class RxUploadProgress extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUploadProgress.type, message);
            this.proto = compiled_1.sfiles.UploadProgress.create({});
            this.protoClass = compiled_1.sfiles.UploadProgress;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUploadProgress(message);
        }
        ;
    }
    RxUploadProgress.type = 'upload-progress';
    proto_1.RxUploadProgress = RxUploadProgress;
    class TxUploadStart extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxUploadStart.type, true);
            this.protoClass = compiled_1.sfiles.UploadStart;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxUploadStart(compiled_1.sfiles.UploadStart.create(properties));
        }
    }
    TxUploadStart.type = 'upload-start';
    proto_1.TxUploadStart = TxUploadStart;
    class RxUploadStartSlot extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUploadStartSlot.type, message);
            this.proto = compiled_1.sfiles.UploadStartSlot.create({});
            this.protoClass = compiled_1.sfiles.UploadStartSlot;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUploadStartSlot(message);
        }
        ;
    }
    RxUploadStartSlot.type = 'upload-start';
    proto_1.RxUploadStartSlot = RxUploadStartSlot;
    class RxAck extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxAck.type, message);
            this.proto = compiled_1.socket_api.Ack.create({});
            this.protoClass = compiled_1.socket_api.Ack;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxAck(message);
        }
        ;
    }
    RxAck.type = 'ack';
    proto_1.RxAck = RxAck;
    class RxAsyncProgress extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxAsyncProgress.type, message);
            this.proto = compiled_1.socket_api.AsyncProgress.create({});
            this.protoClass = compiled_1.socket_api.AsyncProgress;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxAsyncProgress(message);
        }
        ;
    }
    RxAsyncProgress.type = 'async-progress';
    proto_1.RxAsyncProgress = RxAsyncProgress;
    class RxUpgradeApiVersion extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUpgradeApiVersion.type, message);
            this.proto = compiled_1.socket_api.UpgradeApiVersion.create({});
            this.protoClass = compiled_1.socket_api.UpgradeApiVersion;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUpgradeApiVersion(message);
        }
        ;
    }
    RxUpgradeApiVersion.type = 'upgrade-api-version';
    proto_1.RxUpgradeApiVersion = RxUpgradeApiVersion;
    class TxDeleteUFile extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxDeleteUFile.type, true);
            this.protoClass = compiled_1.uploader.DeleteUFile;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxDeleteUFile(compiled_1.uploader.DeleteUFile.create(properties));
        }
    }
    TxDeleteUFile.type = 'delete-ufile';
    proto_1.TxDeleteUFile = TxDeleteUFile;
    class RxUploadSlot extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUploadSlot.type, message);
            this.proto = compiled_1.uploader.UploadSlot.create({});
            this.protoClass = compiled_1.uploader.UploadSlot;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUploadSlot(message);
        }
        ;
    }
    RxUploadSlot.type = 'upload-slot';
    proto_1.RxUploadSlot = RxUploadSlot;
    class RxUploadTask extends socket_messages_1.SocketRxMessage {
        constructor(message = null) {
            super(RxUploadTask.type, message);
            this.proto = compiled_1.uploader.UploadTask.create({});
            this.protoClass = compiled_1.uploader.UploadTask;
            if (message !== null) {
                this.proto = this.protoClass.fromObject(message.body);
            }
        }
        fromMessage(message) {
            return new RxUploadTask(message);
        }
        ;
    }
    RxUploadTask.type = 'upload-task';
    proto_1.RxUploadTask = RxUploadTask;
    class TxUploadUFile extends socket_messages_1.SocketTxMessage {
        constructor(proto) {
            super(TxUploadUFile.type, true);
            this.protoClass = compiled_1.uploader.UploadUFile;
            this.proto = proto;
        }
        static create(properties = {}) {
            return new TxUploadUFile(compiled_1.uploader.UploadUFile.create(properties));
        }
    }
    TxUploadUFile.type = 'upload-ufile';
    proto_1.TxUploadUFile = TxUploadUFile;
    proto_1.rxMessages = [
        new RxLoginError(),
        new RxLoginToken(),
        new RxTokenInvalid(),
        new RxFormErrors(),
        new RxUploadDone(),
        new RxUploadProgress(),
        new RxUploadStartSlot(),
        new RxAck(),
        new RxAsyncProgress(),
        new RxUpgradeApiVersion(),
        new RxUploadSlot(),
        new RxUploadTask()
    ];
})(proto = exports.proto || (exports.proto = {}));
